import { Box, Typography } from "@mui/material";

const cells = [
  0, 1, 2, 3,
  1, 2, 3, 4,
];

export default function NeuLoader({
  size = "md",
  label,
  fullScreen = false,
  inline = false,
}) {
  const dimensions = {
    sm: { cell: 10, gap: 4  },
    md: { cell: 14, gap: 5 },
    lg: { cell: 18, gap: 6 },
  };

  const { cell, gap } = dimensions[size] || dimensions.md;
  const columns = 4;
  const width = columns * cell + (columns - 1) * gap;

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: label ? 2 : 0,
      }}
    >
      <Box
        sx={(theme) => ({
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, ${cell}px)`,
          gap: `${gap}px`,
          width,
        })}
      >
        {cells.map((delay, index) => (
          <Box
            key={index}
            sx={(theme) => ({
              width: cell,
              height: cell,
              borderRadius: "2px",
              backgroundColor: "transparent",
              animation: "neuLoaderRipple 1.4s ease-in-out infinite",
              animationDelay: `${delay * 120}ms`,
              "@keyframes neuLoaderRipple": {
                "0%": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  opacity: 0.2,
                },
                "30%": {
                  backgroundColor: theme.palette.primary.main,
                  border: theme.custom.borders.sharp,
                  opacity: 1,
                  ...theme.applyStyles("dark", {
                    border: "transparent",
                  }),
                },
                "60%": {
                  backgroundColor: "transparent",

                  opacity: 0.35,
                },
                "100%": {
                  backgroundColor: "transparent",

                  opacity: 0.2,
                },
              },
            })}
          />
        ))}
      </Box>

      {label ? (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      ) : null}
    </Box>
  );

  if (inline) return content;

  if (fullScreen) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
      }}
    >
      {content}
    </Box>
  );
}